module.exports = __webpack_public_path__ + "img/IMG_20200317_192025_596 - Asjad Ali Khan 19MEB436 (1).50178071.jpg";